angular.module('ecrd.record.bulk').component('recordBulkStatus', {
    controller: 'RecordBulkStatusController',
    templateUrl: 'modules/record-bulk/components/record-bulk-status/template.html',
    bindings: {
        // Lista de registros afectados
        records: '<',
    },
});
